export default "__VITE_ASSET__f6e1169b__"